import script from "./ManagerSelectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerSelectPage.vue?vue&type=script&setup=true&lang=js"

import "./ManagerSelectPage.vue?vue&type=style&index=0&id=5636ec04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5636ec04"]])

export default __exports__